import React, { useEffect } from 'react'
import "./refundPolicy.css"
import JoinRibbon from '../../components/JoinRibbon'
import Navbar from '../../Layout/NavBar'
import FAQSection from '../LandingPage/FAQ_Section'
import TestimonialSection from '../LandingPage/testimonialSection/TestimonialSection'
import { useSelector } from 'react-redux'
function RefundPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

      const fbp = useSelector(state => state.fb?.fbp)
      const fbc = useSelector(state => state.fb?.fbc)
    
      useEffect(() => {
        console.log("fb_datax", fbp, fbc);
        
      }, [])
  return (
    <div className='refundpolicy-page'>
    <Navbar type={1}  />
        
        <div className='rp-content-wp'>
            <h1 className='rp-header'>Refund And Policy</h1>
            <p className='rp-desc'>Thank you for choosing our tech interview preparation program. We are dedicated to delivering an exceptional learning experience that equips you with the skills to excel in high-stakes technical interviews. Our curated curriculum, developed with insight from competitive programming expertise and industry experience, is designed to be both targeted and accessible.</p>

            <div className='rp-wp'>
                <h4 className='rp-header'>Refund Eligibility</h4>
                <p className='rp-desc'>Given the digital nature of our course content and its immediate accessibility upon purchase, we maintain a strict refund policy to ensure fair use of our resources. Refunds will only be considered under the following circumstances:
                </p>
                <ul className='list-wp'>
                    <li>
                        <div>
<h4 className='rp-header'>Technical Issues</h4>
<p className='rp-desc'>If you experience a technical issue that prevents access to the course content, please reach out to our support team within 7 days of purchase. We’ll work to resolve the issue and may offer a partial or full refund if we cannot provide access.</p>
                        </div>
                    </li>

                    <li>
                        <div>
<h4 className='rp-header'>Quality Concerns</h4>
<p className='rp-desc'>If you believe that the course content does not meet the quality standards we’ve promised, contact us within 7 days of purchase. Please provide specific feedback on the areas that did not meet expectations, and we’ll review your case for a potential refund.</p>
                        </div>
                    </li>

                    <li>
                        <div>
<h4 className='rp-header'>Duplicate Payments</h4>
<p className='rp-desc'>In cases where accidental duplicate payments occur, please notify us within 14 days. We will promptly process a refund for the duplicate charge.</p>
                        </div>
                    </li>

                    <li>
                        <div>
<h4 className='rp-header'>Time period</h4>
<p className='rp-desc'>We offer a 3-day satisfaction guarantee. If you’re not fully satisfied with the program, contact our support team within 3 days of purchase for assistance.</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div className='rp-wp'>
                <h4 className='rp-header'>Non-Refundable Circumstances</h4>
                <p className='rp-desc'>Due to the immediate availability and low-cost nature of our program, we do not offer refunds in the following cases:</p>

                <ul className='list-wp'>
                <li>
                        <div>
<h4 className='rp-header'>Change of mind</h4>
<p className='rp-desc'>Once you’ve accessed the material, we consider the purchase final.</p>
                        </div>
                    </li>

                    <li>
                        <div>
<h4 className='rp-header'>Failure to complete the program:</h4>
<p className='rp-desc'>As our program is self-paced, we encourage you to use your time effectively but cannot offer refunds for incomplete progress.</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div className='rp-wp'>
                <h4 className='rp-header'>How to Request a Refund</h4>
                <p className='rp-desc'>If you meet the eligibility requirements, please email our support team at [support@dsasimplified.com or refund@dsasimplified.com] with your purchase details, including the transaction ID, date of purchase, and a brief description of your issue. We aim to review and respond to all refund requests within 5-7 business days.</p>
            </div>
           
            <div className='rp-wp'>
                <h4 className='rp-header'>Need help?</h4>
                <p className='rp-desc'>Contact us at refund@dsasimplified.com for questions related to refunds and returns.</p>
            </div>
            

        </div>
        <FAQSection />
        <TestimonialSection />
        <JoinRibbon />
    </div>
  )
}

export default RefundPolicy